<template>
  <v-app-bar
    ref="appbar"
    light
    dense
    fixed
    clipped-left
    clipped-right
    elevate-on-scroll
    dark
    :color="background_color"
    :app="is_appbar"
    v-scroll="onScroll"
  >
    <!-- <v-toolbar-items> -->
    <v-toolbar-title>
      <router-link :to="{ name: 'home' }" class="primary--text" style="text-decoration:none;">
        <v-img src="/img/logo.svg" class="my-3" contain width="105" height="30"></v-img>
      </router-link>
    </v-toolbar-title>
    <!-- </v-toolbar-items> -->

    <template v-if="$vuetify.breakpoint.mdAndDown">
      <v-menu v-model="active_sm_nav" offsetY>
        <template v-slot:activator="{ on }">
          <v-btn text color="primary" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(nav,i) in navigation"
            :key="i"
            v-if="(nav.requiresAuth == false || (nav.requiresAuth == true && authenticated))"
            :to="nav.link"
          >
            <v-list-item-title>{{ nav.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <v-spacer></v-spacer>

    <template v-if="$vuetify.breakpoint.lgAndUp">
      <v-btn
        :text="!nav.outlined"
        :outlined="nav.outlined"
        :small="!nav.only_icon"
        rounded
        exact
        color="primary"
        class="mr-1"
        :icon="nav.only_icon"
        v-for="(nav,i) in navigation"
        :key="i"
        v-if="(nav.requiresAuth == false || (nav.requiresAuth == true && authenticated))"
        :to="!nav.reuqiredModal ? nav.link: null"
        @click="()=>{if(nav.reuqiredModal)modal_active = true }"
      >
        <span v-if="!nav.only_icon">{{ nav.title }}</span>

        <v-icon :small="!nav.only_icon" v-if="nav.icon" :right="!nav.only_icon">{{nav.icon}}</v-icon>
      </v-btn>
      <v-badge
        v-if="authenticated"
        :content="unreadNotifications"
        :value="unreadNotifications"
        class="mr-3"
        overlap
        color="transparent"
      >
        <v-btn
          text
          rounded
          small
          color="primary"
          :icon="notification_nav.only_icon"
          v-if="(notification_nav.requiresAuth == false || (notification_nav.requiresAuth == true && authenticated))"
          :to="notification_nav.link"
        >
          <span v-if="!notification_nav.only_icon">{{ notification_nav.title }}</span>

          <v-icon
            v-if="notification_nav.icon"
            :right="!notification_nav.only_icon"
          >{{notification_nav.icon}}</v-icon>
        </v-btn>
      </v-badge>
    </template>

    <v-btn rounded color="primary" small v-if="!authenticated" text @click="openAuthModal(0)">
      <span>{{ this.trans('app.nav_sign_up', null, "...") }}</span>
    </v-btn>

    <v-btn
      rounded
      small
      v-if="!authenticated"
      depressed
      color="primary"
      outlined
      @click="openAuthModal(1)"
    >
      <span>{{ this.trans('app.nav_sign_in', null, "...") }}</span>
    </v-btn>

    <v-btn rounded small v-if="authenticated" depressed color="#000" outlined @click="logout">
      <span>{{ this.trans('app.nav_logout', null, "...") }}</span>
    </v-btn>

    <auth
      :active="modal_active && !authenticated"
      :tab="modal_tab"
      @close="modal_active = false"
      @change="(i) => {modal_tab = i}"
    ></auth>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Auth from "../views/Auth";
import EventBus from "../event_bus";

export default {
  components: {
    auth: Auth
  },
  data: () => ({
    modal_active: false,
    modal_tab: 0,
    active_sm_nav: false,
    // pending_redirect: null,
    background_color: "#fff"
  }),

  computed: {
    ...mapState("auth", {
      authenticated: "authenticated"
    }),
    ...mapGetters("notifications", {
      unreadNotifications: "unreadNotifications"
    }),

    linkToAdverts: function() {
      return this.authenticated
        ? { name: "my-adverts" }
        : { name: "my-adverts-edit" };
    },

    navigation: function() {
      let items = [
        {
          title: this.trans("app.nav_adverts", null, "..."),
          link: { name: "my-adverts-edit" },
          requiresAuth: false,
          badge: null,
          icon: "mdi-plus",
          outlined: true,
          reuqiredModal: !this.authenticated
        },
        {
          title: this.trans("app.nav_preferences", null, "..."),
          link: { name: "my-preferences-edit" },
          requiresAuth: false,
          badge: null,
          icon: "mdi-plus",
          outlined: true,
          reuqiredModal: !this.authenticated
        },
        {
          title: this.trans("app.nav_search", null, "..."),
          link: { name: "search" },
          requiresAuth: false,
          badge: null,
          icon: "mdi-magnify"
        },

        {
          title: this.trans("app.nav_adverts_list", null, "..."),
          link: { name: "my-adverts" },
          requiresAuth: true,
          badge: null,
          icon: "mdi-home-variant-outline"
        },

        {
          title: this.trans("app.nav_subscriptions", null, "..."),
          link: { name: "subscriptions" },
          requiresAuth: true,
          badge: null,
          icon: "mdi-book-variant-multiple"
        },
        {
          title: this.trans("app.nav_profile", null, "..."),
          link: { name: "my-profile" },
          requiresAuth: true,
          badge: null,
          only_icon: true,
          icon: "mdi-account"
        },
        {
          title: this.trans("app.nav_favorites", null, "..."),
          link: { name: "my-favorites" },
          requiresAuth: true,
          badge: null,
          only_icon: true,
          icon: "mdi-heart"
        }
      ];

      // if (!this.is_homepage) {
      // 	items.splice(0, 0, {
      // 		title: this.trans('app.nav_search', null, 'Search'),
      // 		link: { name: 'search' },
      // 		requiresAuth: false,
      // 		badge: null,
      // 	})
      // }

      return items;
    },
    notification_nav() {
      return {
        title: this.trans("app.nav_notifications", null, "..."),
        link: { name: "notifications" },
        requiresAuth: true,
        badge: 5 || null,
        icon: "mdi-bell",
        only_icon: true
      };
    },

    is_appbar: function() {
      if (this.is_homepage) {
        return false;
      }
      return true;
    },

    is_homepage: function() {
      if (this.$route.name == "home") return true;
      return false;
    }
  },

  mounted: function() {
    EventBus.$on("requiresAuth", next => {
      this.modal_active = true;
      this.modal_tab = 1;
      // this.pending_redirect = next;
    });

    EventBus.$on("dismissAuth", () => {
      this.modal_active = false;
    });

    if (this.authenticated) {
      this.$store.dispatch("notifications/fetch");
    }

    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "auth/login") this.$store.dispatch("notifications/fetch");
    });
  },

  methods: {
    ...mapActions("auth", {
      logout: "logout"
    }),

    onScroll: function(e) {
      var alpha = 1;
      if (this.$route.name == "home") {
        let val = e.target.scrollingElement.scrollTop;
        // let alpha = Math.min(1, Math.abs(0 - (val * 0.01)) );
        if (val > 0) {
          alpha = 1;
        } else {
          alpha = 0;
        }
      } else {
        alpha = 1;
      }
      //  this.background_color = `rgba(31,218,141,${alpha})`;
    },

    /*
		onLogin: function(state) {
			if (this.pending_redirect) {
				let next = this.pending_redirect;
				return next();
			}
		},
		*/

    openAuthModal: function(tab) {
      if (this.authenticated) {
        this.modal_active = false;
      }
      this.modal_active = true;
      this.modal_tab = tab;
    }
  }
};
</script>
